import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getLeadSourceCampaignListData } from './mockData'
import type { ILeadSourceCampaign } from '~/types/leadSource/models'

// get

interface GetLeadSourceCampaignsResponse {
  data: ILeadSourceCampaign[]
}

async function getLeadSourceCampaigns(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetLeadSourceCampaignsResponse = {
    data: await getLeadSourceCampaignListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postLeadSourceCampaign = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getLeadSourceCampaignListData)
}

const patchLeadSourceCampaign = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getLeadSourceCampaignListData)
}

const deleteLeadSourceCampaign = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getLeadSourceCampaignListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/leadsourcecampaigns',
    handler: getLeadSourceCampaigns,
  },
  {
    method: 'post',
    path: '/api/leadsourcecampaigns',
    handler: postLeadSourceCampaign,
  },
  {
    method: 'patch',
    path: '/api/leadsourcecampaigns/:id',
    handler: patchLeadSourceCampaign,
  },
  {
    method: 'delete',
    path: '/api/leadsourcecampaigns/:id',
    handler: deleteLeadSourceCampaign,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
